import { WebPlugin } from '@capacitor/core';
export class PianoDmpWeb extends WebPlugin {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async sendPageView(_options) {
        throw new Error('Not implemented on web');
    }
}
//# sourceMappingURL=web.js.map